import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=0112336a&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=0112336a&prod&lang=css"
import style1 from "./pay.vue?vue&type=style&index=1&id=0112336a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0112336a",
  null
  
)

export default component.exports